import { shippingFactors } from '@/mocks/features';

export default function ShippingGuide() {
  return (
    <section id="shipping" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block text-xs font-semibold text-accent-600 uppercase tracking-wider mb-3 bg-accent-100 px-3 py-1 rounded-full">
            Shipping
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
            Sugargoo Shipping Cost Guide
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Understanding how Sugargoo shipping costs are calculated and how to minimize your delivery expenses
          </p>
        </div>

        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
          <div className="lg:w-1/2">
            <div className="grid grid-cols-2 gap-4 mb-8">
              <div className="p-5 bg-background-50 rounded-lg border border-background-200/70 text-center">
                <div className="w-10 h-10 mx-auto flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mb-3">
                  <i className="ri-plane-line text-lg"></i>
                </div>
                <p className="text-xs text-foreground-500 mb-1">Shipping Methods</p>
                <p className="text-lg font-heading font-bold text-foreground-950">
                  Multiple Lines
                </p>
              </div>
              <div className="p-5 bg-background-50 rounded-lg border border-background-200/70 text-center">
                <div className="w-10 h-10 mx-auto flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mb-3">
                  <i className="ri-scales-line text-lg"></i>
                </div>
                <p className="text-xs text-foreground-500 mb-1">Weight Based</p>
                <p className="text-lg font-heading font-bold text-foreground-950">
                  Per Gram Pricing
                </p>
              </div>
              <div className="p-5 bg-background-50 rounded-lg border border-background-200/70 text-center">
                <div className="w-10 h-10 mx-auto flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mb-3">
                  <i className="ri-time-line text-lg"></i>
                </div>
                <p className="text-xs text-foreground-500 mb-1">Delivery Time</p>
                <p className="text-lg font-heading font-bold text-foreground-950">
                  5-20 Days
                </p>
              </div>
              <div className="p-5 bg-background-50 rounded-lg border border-background-200/70 text-center">
                <div className="w-10 h-10 mx-auto flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mb-3">
                  <i className="ri-global-line text-lg"></i>
                </div>
                <p className="text-xs text-foreground-500 mb-1">Coverage</p>
                <p className="text-lg font-heading font-bold text-foreground-950">
                  Worldwide
                </p>
              </div>
            </div>
          </div>

          <div className="lg:w-1/2">
            <div className="overflow-hidden rounded-lg border border-background-200/70">
              <table className="w-full text-sm">
                <thead>
                  <tr className="bg-background-200/70">
                    <th className="text-left px-4 py-3 font-semibold text-foreground-800">Shipping Factor</th>
                    <th className="text-left px-4 py-3 font-semibold text-foreground-800">Impact Level</th>
                    <th className="text-left px-4 py-3 font-semibold text-foreground-800 hidden sm:table-cell">Description</th>
                  </tr>
                </thead>
                <tbody>
                  {shippingFactors.map((item) => (
                    <tr key={item.factor} className="border-t border-background-200/50">
                      <td className="px-4 py-3 font-medium text-foreground-800">{item.factor}</td>
                      <td className="px-4 py-3">
                        <span className={`inline-block px-2.5 py-0.5 rounded-full text-xs font-semibold ${item.impact === 'High' ? 'bg-primary-100 text-primary-700' : 'bg-secondary-100 text-secondary-700'}`}>
                          {item.impact}
                        </span>
                      </td>
                      <td className="px-4 py-3 text-foreground-500 text-xs hidden sm:table-cell">{item.description}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 mt-6 text-sm font-semibold text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Calculate your shipping cost
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}